import { Box } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { ForwardComposerPreview } from '../ForwardComposerPreview';
import type { ForwardComposerInputProps } from '../ForwardComposerFooter';
import { ForwardComposerInput } from '../ForwardComposerFooter';

export interface ForwardComposerProps extends ForwardComposerInputProps {
  message?: Msg;
}

export function ForwardComposer({ message, ...props }: ForwardComposerProps) {
  return (
    <Box className="ForwardComposer" bg="white" my="6" borderRadius="md" w="full">
      <ForwardComposerPreview message={message} />
      <ForwardComposerInput {...props} />
    </Box>
  );
}
